var _use, _defs, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68.25 71.25",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 3.125,
    y: 3.125
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "91.90%",
    y1: "40.22%",
    x2: "28.49%",
    y2: "81.63%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "8.70%",
    y1: "59.17%",
    x2: "72.26%",
    y2: "17.99%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2684ff"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "C",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.161 30.211L30.95 0 .74 30.211a2.54 2.54 0 0 0 0 3.581l30.211 30.21 30.211-30.21a2.54 2.54 0 0 0 0-3.581zM30.95 41.46l-9.462-9.462 9.462-9.462 9.462 9.462z",
    fill: "#2684ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.95 22.599C24.755 16.405 24.724 6.37 30.881.138L10.114 20.774l11.268 11.268z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.437 31.973L30.95 41.46a15.93 15.93 0 0 1 0 22.536l20.749-20.749z",
    fill: "url(#B)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.2a8b74c6cfeeb608658225405f52e3e9.svg";
export { ForwardRef as ReactComponent };